import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ChevronLeft } from 'lucide-react-native';
import { memo, ReactNode } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

/**
 * A page's top bar: back, a title over a muted subtitle, and whatever the
 * page puts before the title or after it.
 */
export const SubtitledHeader = memo(
  ({
    title,
    subtitle,
    onBack,
    leading,
    trailing,
  }: {
    title: ReactNode;
    subtitle?: string;
    onBack: () => void;
    leading?: ReactNode;
    trailing?: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    const insets = useSafeAreaInsets();
    return (
      <View
        style={{
          paddingTop: insets.top,
          borderBottomWidth: 1,
          borderBottomColor: aiColors.border,
          backgroundColor: aiColors.card,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: rpx(10),
            paddingHorizontal: rpx(12),
            paddingVertical: rpx(10),
          }}
        >
          <TouchableOpacity
            accessibilityRole="button"
            accessibilityLabel="返回"
            onPress={onBack}
            hitSlop={8}
            style={{
              width: rpx(36),
              height: rpx(36),
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ChevronLeft size={rpx(22)} color={aiColors.foreground} />
          </TouchableOpacity>
          {leading}
          <View style={{ flex: 1, minWidth: 0 }}>
            {typeof title === 'string' ? (
              <Typography.Text
                size={rpx(14)}
                bold
                color={aiColors.foreground}
                numberOfLines={1}
              >
                {title}
              </Typography.Text>
            ) : (
              title
            )}
            {subtitle ? (
              <Typography.Text
                size={rpx(11)}
                color={aiColors.mutedForeground}
                numberOfLines={1}
              >
                {subtitle}
              </Typography.Text>
            ) : null}
          </View>
          {trailing}
        </View>
      </View>
    );
  },
);
